import React from 'react';
import { useIntl } from 'react-intl-next';
import { ToolTipContent, addInlineComment } from '@atlaskit/editor-common/keymaps';
import { annotationMessages } from '@atlaskit/editor-common/messages';
import { useEditorToolbar } from '@atlaskit/editor-common/toolbar';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import { ToolbarButton, CommentIcon as NewCommentIcon, ToolbarTooltip } from '@atlaskit/editor-toolbar';
import { fg } from '@atlaskit/platform-feature-flags';
import { isSelectionValid } from '../../pm-plugins/utils';
import { AnnotationSelectionType, AnnotationTestIds } from '../../types';
import { useCommentButtonMount } from './hooks';
import { fireOnClickAnalyticsEvent, isButtonDisabled, shouldShowCommentButton, startCommentExperience } from './utils';
export var CommentButton = function CommentButton(_ref) {
  var api = _ref.api,
    annotationProviders = _ref.annotationProviders;
  var isVisible = useSharedPluginStateSelector(api, 'annotation.isVisible');
  var bookmark = useSharedPluginStateSelector(api, 'annotation.bookmark');
  var _useEditorToolbar = useEditorToolbar(),
    editorView = _useEditorToolbar.editorView;
  var _ref2 = editorView !== null && editorView !== void 0 ? editorView : {
      state: null,
      dispatch: null
    },
    state = _ref2.state,
    dispatch = _ref2.dispatch;
  var annotationSelectionType = state ? isSelectionValid(state) : AnnotationSelectionType.INVALID;
  useCommentButtonMount({
    state: state,
    annotationProviders: annotationProviders,
    api: api,
    annotationSelectionType: annotationSelectionType,
    bookmark: bookmark
  });
  var intl = useIntl();
  var onClick = function onClick() {
    if (!api || !state || !dispatch || !annotationProviders) {
      return;
    }
    fireOnClickAnalyticsEvent({
      api: api
    });
    startCommentExperience({
      annotationProviders: annotationProviders,
      api: api,
      state: state,
      dispatch: dispatch
    });
  };
  if (!shouldShowCommentButton({
    state: state,
    isVisible: isVisible,
    annotationSelectionType: annotationSelectionType
  })) {
    return null;
  }
  var commentMessage = intl.formatMessage(annotationMessages.createComment);
  var commentDisabledMessage = intl.formatMessage(fg('editor_inline_comments_on_inline_nodes') ? annotationMessages.createCommentDisabled : annotationMessages.createCommentInvalid);
  var isDisabled = isButtonDisabled({
    state: state,
    api: api
  });
  return /*#__PURE__*/React.createElement(ToolbarTooltip, {
    content: isDisabled ? commentDisabledMessage : /*#__PURE__*/React.createElement(ToolTipContent, {
      description: commentMessage,
      keymap: addInlineComment
    })
  }, /*#__PURE__*/React.createElement(ToolbarButton, {
    iconBefore: /*#__PURE__*/React.createElement(NewCommentIcon, {
      label: "",
      size: "small"
    }),
    onClick: onClick,
    testId: AnnotationTestIds.floatingToolbarCreateButton,
    isDisabled: isDisabled
  }, commentMessage));
};